webpackJsonp([254336481176044],{

/***/ 1446:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"HfdProgramCodeInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"code","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-hfd-program-code-input-1bd071820fa7dd87efad.js